<script>
	import {
		EthiClaims,
		DateRange,
		IsDev,
		IsElectron,
		Platform,
		IsNative,
		Path,
		UserToken,
		UserInfo,
		UserEmail,
		Version
	} from '$lib/store.js';
	console.log($Version);
	import { goto } from '$app/navigation';
	import { storeLocal, getUserInfo, decodeJWT, currentTime } from '$lib/utils.js';
	import { signup, login, confirmPasswordReset, getAuth } from '$lib/authapi.js';
	import { resetPassword } from '$lib/authapi.js';

	import { whoopLogin } from '$lib/connectUtils.js';
	import ListErrors from '../components/ListErrors.svelte';
	import ROICalculator from '../components/ROICalculator.svelte';
	import Toast from '../components/Toast.svelte';
	import Modal from '../components/Modal.svelte';
	import Switch from '../components/Switch.svelte';

	import { page } from '$app/stores';
	import { fade } from 'svelte/transition';
	import { onMount } from 'svelte';

	let taskContent = {
		login: {
			title: 'Sign in',
			submitButton: 'Sign in',
			submitFunction: submitLogin,
			loading: 'Signing you in...',
			swap: { text: 'Create Account', task: 'register' }
		},
		register: {
			title: 'Create an account',
			submitButton: 'Create account',
			submitFunction: submitCreate,
			loading: 'Creating your account...',
			swap: { text: 'Sign in to your account', task: 'login' }
		},
		reset: {
			title: 'Reset your password',
			submitButton: 'Reset',
			submitFunction: submitReset,
			loading: 'Resetting your password...',
			swap: { text: 'Log in', href: '/login' }
		},
		whoopLogin: {
			title: 'Sign in to Whoop',
			submitButton: 'Sign in',
			submitFunction: submitWhoopLogin,
			loading: 'Signing you in...',
			swap: { text: 'Go Back', href: '/data' }
		}
	};

	export let task =
		$IsElectron || typeof window === 'undefined'
			? ''
			: (taskContent[$Path.slice(1)] && $Path.slice(1)) || 'register';
	export let accountEmail;
	export let error;
	export let actionCode;
	export let redirect;

	let email = accountEmail || '';
	let password = '';
	let confirmPassword = '';
	let errors = [];
	$: if (error) updateErrors();
	let updateErrors = () => (errors = [...(errors || []), error]);

	let referral;
	let accountCreated, access, userToken;
	let app;
	let show = false;
	onMount(async () => {
		// console.log({ redirect, referral }, $page.url.search);
		if ($IsElectron) window.api?.call('loginPage');

		$Version = (await window.api?.version) || {
			app:
				$page.url.searchParams.app ||
				($page.url.searchParams.get && $page.url.searchParams.get('app'))
		};
		if (window.location.href.includes('omnipilot')) {
			$Version.app = 'omnipilot';
		}
		if ($Version.app == 'omnipilot' && !window.location.href.includes('/ai')) {
			goto('/onboard/demo?app=omnipilot');
		}

		console.log($Version);

		let oauthProvider =
			$page.url.searchParams.oauthProvider ||
			($page.url.searchParams.get && $page.url.searchParams.get('oauthProvider')) ||
			false;
		let rawUserToken =
			$page.url.searchParams.user_token ||
			($page.url.searchParams.get && $page.url.searchParams.get('user_token'));
		false;
		console.log(
			{ rawUserToken, $Version, t: localStorage.userToken },
			(rawUserToken || localStorage.userToken) && $Version.app == 'omnipilot'
		);

		userToken = rawUserToken
			? decodeURIComponent(rawUserToken)
			: checkLocal(localStorage.userToken);

		if (userToken && $Version.app == 'omnipilot') {
			console.log({ userToken });
			localStorage.userToken = userToken;
			let parsedToken = JSON.parse(userToken);

			console.log(parsedToken);
			$UserToken = parsedToken;
			$UserEmail = parsedToken?.email;
			if (parsedToken) {
				getAuth().then(() =>
					goto(
						accountCreated ||
							($Version.app == 'omnipilot' && !$UserInfo.omnipilotOnboardingComplete)
							? '/onboard'
							: '/'
					).then(() => {
						console.log('reloading from Login.svelte post getAuth');
						// window.location.reload();
					})
				);
			}
		}
		access =
			$page.url.searchParams.access_token ||
			($page.url.searchParams.get && $page.url.searchParams.get('access_token')) ||
			false;
		let refresh =
			$page.url.searchParams.refresh_token ||
			($page.url.searchParams.get && $page.url.searchParams.get('refresh_token')) ||
			false;
		accountCreated =
			$page.url.searchParams.created ||
			($page.url.searchParams.get && $page.url.searchParams.get('created')) ||
			false;

		if (access && refresh) {
			localStorage.ethi_access = access;
			localStorage.ethi_refresh = refresh;
			if (userToken) {
				localStorage.userToken = userToken;
				try {
					$UserToken = JSON.parse(userToken);
				} catch (e) {
					console.log('error parsing user token', e);
				}
			}
			getAuth().then(() =>
				goto(
					accountCreated || ($Version.app == 'omnipilot' && !$UserInfo.omnipilotOnboardingComplete)
						? '/onboard'
						: '/'
				).then(() => {
					console.log('reloading from Login.svelte post getAuth');
					window.location.reload();
				})
			);
		}
		let e = ($page.url.searchParams.get && $page.url.searchParams.get('e')) || false;
		if (e) {
			console.log(e);
			email = e
				.split('')
				.map((char) => String.fromCharCode(char.charCodeAt(0) + 6))
				.join('');
		}
		if (!redirect)
			redirect =
				$page.url.searchParams.redirect ||
				($page.url.searchParams.get && $page.url.searchParams.get('redirect')) ||
				false; // `${typeof window !== 'undefined' && window.location.href.split('?')[1].split['=']}`
		referral =
			$page.url.searchParams.ref ||
			($page.url.searchParams.get && $page.url.searchParams.get('ref')) ||
			false;
		if (oauthProvider) login({ provider: oauthProvider, created: task === 'register', redirect });
		else if (redirect && localStorage.ethi_access && localStorage.ethi_refresh) {
			let refreshDetails = decodeJWT(localStorage.ethi_refresh, 'Login194');
			if (refreshDetails.exp < currentTime()) {
				console.log('expired refresh, user needs to log in');
			} else {
				let tokenDetails = decodeJWT(localStorage.ethi_refresh, 'Login198');
				if (tokenDetails.exp < currentTime()) {
					console.log('expired token, refreshing');
					await refresh();
				}
				let redirectURL = `${decodeURIComponent(redirect)
					.split('')
					.map((char) => String.fromCharCode(char.charCodeAt(0) + 6))
					.join('')}/login?access_token=${localStorage.ethi_access}&refresh_token=${
					localStorage.ethi_refresh
				}&user_token=${encodeURIComponent(localStorage.userToken)}`;

				goto(redirectURL);
			}
		}
		show = true;
		console.log({ redirect, referral });
		// if ($Version.app == 'omnipilot') {
		// 	window.api?.call('');
		// }
	});

	let showLoggedIn;
	let isLoading = false;
	$: if (
		task === 'register' &&
		showLoggedIn !== false &&
		$EthiClaims?.email &&
		!isLoading &&
		localStorage.ethi_refresh &&
		decodeJWT(localStorage.ethi_refresh, 'Login228')?.exp > currentTime()
	) {
		showLoggedIn = true;
	}

	let marketing = false;
	async function submitCreate() {
		errors = [];
		if (marketing === undefined) {
			errors = [...(errors || []), 'Decide if you want to stay in the loop'];
			return;
		}
		isLoading = true;
		await signup(email, password, 'be1577ta', referral, marketing)
			.then((res) => {
				if (res && res.ok) {
					accountCreated = true;
					if ($Version.app == 'omnipilot')
						fetch(
							'https://delayer-michaeljelly.replit.app/delay?endpoint=https://zapier.magicflow.workers.dev/?email=' +
								email +
								'&delay=369000'
						).catch((e) => console.error(e));
					login({ email, password, redirect, created: true })
						.then(() => goto(!($IsNative || $IsElectron) ? '/onboard' : '/onboard'))
						.catch((e) => console.error(e) || (errors = [...(errors || []), e]));
				} else {
					if (!(res && res.json)) {
						isLoading = false;
						errors = [...(errors || []), 'Server Error! Try again.'];
						return;
					}
					res.json().then((e) => {
						isLoading = false;
						errors = [...(errors || []), e];
						return;
					});
				}
			})
			.catch((e) => {
				console.error(e);
				isLoading = false;
				errors = [...(errors || []), e];
			});
	}

	async function submitLogin() {
		isLoading = true;
		await login({ email, password, redirect }).catch((e) => {
			errors = [...(errors || []), e.message || e];
		});
		setTimeout(() => {
			$DateRange.daysInPast = $DateRange.daysInPast;
		}, 2500);
		isLoading = false;
	}
	async function submitReset(event) {
		errors = [];
		if (!actionCode) {
			forgot = true;
			await resetPassword(email);
			// reset = false;
			setTimeout(() => {
				task = 'login';
				forgot = false;
			}, 4000);
			return;
		}
		if (password !== confirmPassword) {
			errors = ['The passwords entered are not the same.'];
			return;
		}
		isLoading = true;
		// On submit, call resetPassword
		let accountEmail = await confirmPasswordReset(actionCode, confirmPassword).catch((e) => {
			errors = [...(errors || []), e];
		});
		console.log('accountEmail', accountEmail);
		currentTask.loading = 'Reset successful. Logging back in...';
		await login({ email: accountEmail, password }).catch((e) => console.error(e), goto('/login'));
		isLoading = false;
	}
	async function submitWhoopLogin() {
		isLoading = true;
		await whoopLogin(email, password)
			.then((u) => goto('/data'))
			.catch(
				(error) =>
					(errors = [
						...(errors || []),
						'Login unsuccessful, try again or contact hello@' +
							($Version.app === 'omnipilot' ? 'omnipilot.ai' : 'magicflow.com') +
							'. Error: ' +
							error
					])
			);
		isLoading = false;
	}

	$: currentTask = taskContent[task];
	let forgot = false;
	let deviceHeight;
	let setHeight = (node) => {
		deviceHeight = node?.getBoundingClientRect().height;
	};
	let showPw = false;

	let terms;
	$: console.log('shouldBeRendering', currentTask);
</script>

<Toast showToast={errors && errors?.length} on:close={() => (errors = [])}>
	<div class="flex flex-col gap-4 my-4 text-center text-sm">
		<h3 class="text-center">ERROR</h3>
		<ListErrors {errors} brokenThing={task} />
		{#if errors?.[0]?.code === 'auth/email-already-in-use'}
			<button class="flip" on:click={submitLogin}>
				{isLoading ? 'Signing in...' : 'Sign in with these credentials'}
			</button>
		{/if}
		<div>
			Try again or drop us an email at hello@{$Version.app === 'omnipilot'
				? 'omnipilot.ai'
				: 'magicflow.com'}!
		</div>
	</div>
</Toast>
<!-- {#if currentTask && currentTask.swap}
	<svg
		xmlns="http://www.w3.org/2000/svg"
		class="absolute top-0 left-0 h-10 w-12 pl-4 p-2 text-gray-500"
		fill="none"
		viewBox="0 0 24 24"
		stroke="currentColor"
		on:click={() => (task = '')}
	>
		<path
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
			d="M7 16l-4-4m0 0l4-4m-4 4h18"
		/>
	</svg>
{/if} -->
<div
	class="bg-black rounded-lg flex flex-col justify-center h-full w-full items-stretch transition-opacity {show
		? 'opacity-100'
		: 'opacity-0'}"
>
	{#if accountCreated || (redirect && access)}
		<div class="flex flex-col w-full h-full m-auto justify-center items-center uppercase">
			<p>Success!</p>
			<p>Logging you in…</p>
		</div>
	{:else if !forgot}
		{#if !task}
			<div
				in:fade
				class="max-w-md h-full flex w-full flex-col justify-center gap-6 p-6 pb-20 mx-auto my-0"
			>
				<h1 class="text-center text-4xl font-semibold">Supercharge your productivity</h1>
				<!-- <ROICalculator /> -->
				<div>
					{#if $IsElectron && $Platform === 'macos' && $Version.app !== 'omnipilot'}
						<a
							href="http{$IsDev ? '' : 's'}://{$IsDev
								? 'localhost:3000'
								: 'app.' +
								  ($Version.app === 'omnipilot'
										? 'omnipilot.ai'
										: 'magicflow.com')}/register?redirect={encodeURIComponent(
								($Version?.app == 'omnipilot' ? 'omnipilot://' : 'magic://')
									.split('')
									.map((char) => String.fromCharCode(char.charCodeAt(0) - 6))
									.join('')
							)}&app={$Version?.app || 'magicflow'}"
							target="_blank"
						>
							<button class="w-full text-white h-14 mx-auto my-2 text-xl">Get Started</button></a
						>
						<div class="w-full h-14 mx-auto my-2 text-center" on:click={() => (task = 'login')}>
							Sign in
						</div>
					{/if}
					{#if !$IsElectron || $IsDev || $Platform !== 'macos' || $Version.app == 'omnipilot'}
						<button
							class="flip w-full h-14 mx-auto my-2 text-xl"
							on:click={() => (task = 'register')}>Get Started</button
						>
						<button class="w-full mx-auto my-2 text-xl" on:click={() => (task = 'login')}
							>Sign in</button
						>
					{/if}
				</div>
			</div>
		{:else}
			<form
				in:fade
				class="max-w-md flex flex-col w-full justify-center gap-4 p-6 pt-0 pb-24 mx-auto my-0"
				style="height: min(100vw, 100%)"
				on:submit|preventDefault={currentTask.submitFunction}
			>
				<!-- use:setHeight
				style="min-height:{deviceHeight}px" -->
				{#if $Version?.app === 'magicflow'}
					<img class="h-12 mx-auto" src="/logo.webp" alt="Magicflow logo" />
				{:else}
					<img class="h-12 mx-auto" src="/icons/icon.png" alt="Omnipilot logo" />
				{/if}
				<h1 class="text-center text-2xl font-semibold">{currentTask.title}</h1>
				{#if currentTask.swap}
					<a
						style="color:#386fafcc"
						class="-mt-4 text-center cursor-pointer text-sm"
						on:click|preventDefault|stopPropagation={() =>
							currentTask.swap.href
								? goto(currentTask.swap.href)
								: (task = currentTask.swap.task || '')}
						href={currentTask.swap.href}
					>
						or {currentTask.swap.text.toLowerCase()}
					</a>
				{/if}
				<div class="flex flex-col gap-4">
					{#if task !== 'reset' || !actionCode}
						<label for="email">
							<div>Email</div>
							<input
								id="email"
								type="email"
								required
								autocomplete="email"
								placeholder="your@workemail.com"
								bind:value={email}
							/>
						</label>
					{:else}
						<label class="" for="new_password">
							<div>New password</div>
							<input
								id="new_password"
								autocomplete="new-password"
								required
								type={!showPw ? 'password' : 'text'}
								placeholder="NewPassword123!"
								on:input={(e) => (confirmPassword = e.target.value)}
							/>
							<svg
								on:click={() => (showPw = !showPw)}
								xmlns="http://www.w3.org/2000/svg"
								class="h-5 w-5 absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer {!showPw
									? 'text-gray-500'
									: ''}"
								style="left:unset"
								viewBox="0 0 20 20"
								fill="currentColor"
							>
								<path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
								<path
									fill-rule="evenodd"
									d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
									clip-rule="evenodd"
								/>
							</svg>
						</label>
					{/if}
					{#if task !== 'reset' || actionCode}
						<label class="" for="password">
							<div>{task !== 'reset' ? 'Password' : 'Confirm password'}</div>
							<input
								id="password"
								required
								autocomplete={task !== 'reset' ? 'current-password' : 'new-password'}
								type={!showPw ? 'password' : 'text'}
								placeholder={task !== 'reset' ? 'StrongPassword1!' : 'NewPassword123'}
								on:input={(e) => (password = e.target.value)}
							/>
							<svg
								on:click={() => (showPw = !showPw)}
								xmlns="http://www.w3.org/2000/svg"
								class="h-5 w-5 absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer {!showPw
									? 'text-gray-500'
									: ''}"
								style="left:unset"
								viewBox="0 0 20 20"
								fill="currentColor"
							>
								<path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
								<path
									fill-rule="evenodd"
									d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
									clip-rule="evenodd"
								/>
							</svg>
						</label>
					{/if}
					<!-- <div class="text-gray-300 my-4 text-center tracking-tight font-semibold">
							Join 4892 optimizers getting our emails?
						</div>
						<div class="flex mb-4 justify-center">
							{#each ['Yes please!', 'No thanks.'] as choice, i}
								<button
									class="mx-4 p-1 w-32 secondary"
									class:flip={marketing === (choice === 'Yes please!')}
									on:click|preventDefault={() => (marketing = choice === 'Yes please!')}
								>
									{choice}
								</button>
							{/each}
						</div> -->
				</div>

				<div class="flex flex-col gap-6">
					{#if task === 'login'}
						<div class="w-max mx-auto flex flex-col gap-4">
							<div
								class="text-gray-200 text-center text-xs font-semibold cursor-pointer"
								on:click={() => (task = 'reset')}
							>
								Forgot your password?
							</div>
							<div class="text-center text-xs">
								<span>
									By {task == 'register' ? 'creating an account' : 'signing in'}, I agree to the
									<a
										class="text-white font-bold inline"
										href="https://github.com/ethi-technologies/policies/blob/master/ethi-privacy-statement.md"
										target="_blank"
									>
										Privacy Policy
									</a>
									and
									<a
										class="text-white font-bold inline"
										href="https://github.com/ethi-technologies/policies/blob/master/ethi-terms-of-service.md"
										target="_blank"
									>
										Terms of Service.
									</a>
								</span>
							</div>
						</div>
					{:else if task === 'register'}
						<div class="w-max mx-auto flex flex-col gap-4">
							<label class="tos">
								<input type="checkbox" class="inline reinvert" bind:checked={marketing} />
								Subscribe to our updates newsletter?
							</label>
							<label class="tos items-center">
								<input type="checkbox" class="block reinvert" bind:checked={terms} required />
								<span>
									I agree to the
									<a
										class="text-white font-bold inline"
										href="https://github.com/ethi-technologies/policies/blob/master/ethi-privacy-statement.md"
										target="_blank"
									>
										Privacy Policy
									</a>
									and
									<a
										class="text-white font-bold inline"
										href="https://github.com/ethi-technologies/policies/blob/master/ethi-terms-of-service.md"
										target="_blank"
									>
										Terms of Service.
									</a>
								</span>
							</label>
						</div>
					{/if}
					<button
						class="w-full h-14 mx-auto text-xl rounded-xl"
						type="submit"
						disabled={isLoading ||
							(task === 'register' &&
								(!terms || marketing === undefined || !password?.length || !email?.length)) ||
							(task.includes('ogin') && (!password?.length || !email?.length)) ||
							(task === 'reset' && actionCode
								? !(password?.length && confirmPassword?.length)
								: !email?.length)}
					>
						{#if isLoading}
							<span
								class="spinner-border spinner-border-sm"
								style="color:white"
								role="status"
								aria-hidden="true"
							/>
							<span class="sr-only">Loading...</span>{currentTask.loading}
						{:else}{currentTask.submitButton}{/if}
					</button>
					{#if task !== 'reset' && $Version.app != 'omnipilot'}
						<div class="text-center mx-auto">OR</div>
						<button
							disabled={isLoading}
							class=" text-black w-full flex items-center justify-center gap-4 h-14 mx-auto text-xl rounded-xl"
							style="background: white !important;"
							on:click|preventDefault={(e) => {
								$IsElectron
									? window.open(
											`https://app.${
												$Version.app === 'omnipilot' ? 'omnipilot.ai' : 'magicflow.com'
											}/${task}?oauthProvider=google&task=${task}&redirect=${encodeURIComponent(
												($Version?.app == 'omnipilot' ? 'omnipilot://' : 'magic://')
													.split('')
													.map((char) => String.fromCharCode(char.charCodeAt(0) - 6))
													.join('')
											)}&app=${$Version?.app || 'magicflow'}`,
											'_blank'
									  )
									: login({ provider: 'google', created: task === 'register', redirect });
							}}
						>
							{#if isLoading}
								<span
									class="spinner-border spinner-border-sm"
									style="color:white"
									role="status"
									aria-hidden="true"
								/>
								<span class="sr-only">Loading...</span>{currentTask.loading}
							{:else}
								<img src="/logos/google_logo.svg" style="height:1em;" alt="google logo" />
								<span style="color:black;"> Sign in with Google</span>
							{/if}
						</button>
					{/if}
				</div>
			</form>
		{/if}
	{:else}
		<div class="flex flex-col gap-4 h-full w-full justify-center items-center text-center">
			<p>A reset link has been sent (if you have an account).</p>
			<p>Taking you back to login...</p>
		</div>
		<div />
	{/if}
</div>

{#if showLoggedIn}
	<Modal bind:show={showLoggedIn} options={{ cssText: 'width:400px;' }}>
		<div class="flex flex-col items-center gap-4 py-4">
			<p>You're logged in!</p>
			<a on:click|preventDefault={() => goto('/')} href="/">
				<button class="w-48"> Go home </button>
			</a>
		</div>
	</Modal>
{/if}

<style lang="postcss">
	form label input:not([type='checkbox']):focus {
		outline: 1.5px solid #316fe2 !important;
	}
	form label input:not([type='checkbox']) {
		outline: 1.5px solid #416f9244 !important;
		@apply bg-blue-200 focus:bg-opacity-10 bg-opacity-5 dark:opacity-70 text-base p-4 pt-7 normal-case transition-colors focus:outline focus:outline-[#316fe2] rounded-xl;
	}
	input:-webkit-autofill,
	div input:-internal-autofill-selected,
	input:-webkit-autofill:focus {
		filter: invert(1) hue-rotate(180deg) brightness(1.2);
		color: black;
		/* background-color: #ddeeff !important; */
		-webkit-text-fill-color: black !important;
	}

	label {
		@apply text-xs uppercase ml-1 my-2 relative w-full flex flex-col items-stretch;
	}
	label.tos {
		@apply p-0 flex-row normal-case items-center gap-1 my-0;
	}
	label > div {
		@apply absolute left-4 top-2 z-10 pointer-events-none opacity-50;
	}

	button {
		background: linear-gradient(
			153.72deg,
			#0a196a 3.26%,
			#1535c9 73%,
			#316fe2 92.24%,
			#387fe1 95.76%
		);
		color: white;
		height: auto;
		@apply py-4 rounded-xl;
	}
	button:hover {
		filter: none;
		box-shadow: none;
	}
</style>
